var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner spinner--wave",style:(_vm.styles)},[_c('div'),_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }